import isString from './is-string';
/**
 * https://github.com/developit/dlv/blob/master/index.js
 * @param obj
 * @param key
 * @param defaultValue
 */
export default (function (obj, key, defaultValue) {
  var p = 0;
  var keyArr = isString(key) ? key.split('.') : key;
  while (obj && p < keyArr.length) {
    obj = obj[keyArr[p++]];
  }
  return obj === undefined || p < keyArr.length ? defaultValue : obj;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/get.js
// module id = 106
// module chunks = 0